import { Text, Img, Heading } from "./..";
import React from "react";

export default function UserProfile1({
  userImage = "images/img_image_54.png",
  userName = "Dr. Anil Sachdev",
  userLinkIcon = "images/img_link_blue_800.svg",
  userDescription = "Ex-Principal Technical Fellow General Motors R&D, Michigan, USA",
  ...props
}) {
  return (
    <div {...props} className={`${props.className} relative w-full md:h-auto`}>
      <Img src={userImage} alt="Profile Image" className="w-full h-full object-cover" />
      <div className="absolute bottom-[10%] my-auto ml-[30px] mr-auto flex flex-1 flex-col md:left-2 sm:items-start sm:justify-start">
        <div className="flex items-center gap-[7px] self-stretch">
          <Heading size="heading3xl" as="h5" className="text-[20.22px] font-bold text-white">
            {userName}
          </Heading>
          <Img src={userLinkIcon} alt="Link Image" className="h-[16px]" />
        </div>
        <Text size="textsm" as="p" className="relative mt-[-2px] text-[11.19px] font-normal text-white">
          {userDescription}
        </Text>
      </div>
    </div>
  );
}
